<template>
   <nav>
       <v-app-bar dark app class="navi">
           <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>
        <img class="logo" v-on:click="nav('home')" src="@/assets/CogneetivIcon.png" />
      </v-toolbar-title>
           <v-spacer></v-spacer>



       <v-menu
          v-model="menu"
          :close-on-content-click="false"
          elevation="50"
          :max-width="300"
          min-height="150"
          class="navi"
          permanent
          bottom
          origin="center center"
          transition="scale-transition"
        >

              <template v-slot:activator="{ on }">
                <div v-on="on" class="three-dot">
                  <v-icon class="text-color-2">mdi-dots-horizontal</v-icon>
                </div>
              </template>


          <v-card>

            <v-list rounded class="navi" >
              <v-list-item-group v-model="item" color="#10163a">
                <v-list-item v-for="(item, i) in items" :key="i" @click="nav(item.nav)">
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-menu>
       </v-app-bar>




      <v-navigation-drawer  v-model="drawer" dark app class="primary lighten-5">
          <v-layout column align-center >
               <v-flex class="mt-4 mb-4">
                    <v-avatar size="100">
                            <img src="@/assets/companylogo2.png" alt="">
                    </v-avatar>
                    <p class="gray--text subheading mt-1 text-center">CELLFUNDS</p>
               </v-flex>
               <v-flex class="mt-4 mb-4">
                <Popup />
               </v-flex>

          </v-layout>




  <v-flex
        sm6
        xs12
        md6
        lg12
>


       <v-card class="theme-bg-card">
    <v-list-item  >
   <sequential-entrance delay="500" fromBottom>

      <v-list-item-content >
        <sequential-entrance delay="3000" >

       <main class="flexbox">
         <Board id="board-1">
           <Card id="card-1" draggable="true">




 <sequential-entrance delay="500" fromBottom>

      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>MARKETING</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 82% </h2></v-list-item-title>
        <v-card-actions>

                 <MarketingProgressBar class="m-center" />

        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>




<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Calls</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >1,428</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Emails</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >168</v-list-item-title>
      </v-column>
    </v-row>
</v-container>

      </v-list-item-content>
     </sequential-entrance>

           </Card>
         </Board>
       </main>


</sequential-entrance>


      </v-list-item-content>
     </sequential-entrance>
    </v-list-item>

  </v-card>
</v-flex>





       <v-flex
        sm6
        xs12
        md6
        lg12
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >


        <main class="flexbox">
         <Board id="board-2">
           <Card id="card-2" draggable="true" >



 <sequential-entrance delay="1000" fromBottom>

      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>SALES</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 72% </h2></v-list-item-title>

        <v-card-actions>

                 <SalesProgressBar class="m-center" />

        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>





<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Quotes</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >25</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Sales</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >6 | $18,452</v-list-item-title>
      </v-column>
    </v-row>
</v-container>




      </v-list-item-content>
      </sequential-entrance>

           </Card>
         </Board>
       </main>

      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>

  </v-card>
</v-flex>




       <v-flex
        sm6
        xs12
        md6
        lg12
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >


        <main class="flexbox">
         <Board id="board-3">
           <Card id="card-3" draggable="true">


 <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>PROJECTS</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 82% </h2></v-list-item-title>


        <v-card-actions>

                 <ProjectsProgressBar class="m-center" />

        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Intakes</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >10</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Pending</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >3</v-list-item-title>
      </v-column>
    </v-row>
</v-container>




      </v-list-item-content>
      </sequential-entrance>





           </Card>
         </Board>
       </main>

      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>

  </v-card>
      </v-flex>



       <v-flex
        sm6
        xs12
        md6
        lg12
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >


        <main class="flexbox">

         <Board id="board-4">
           <Card id="card-4" draggable="true">


   <sequential-entrance delay="2000" fromBottom>

       <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>ACCOUNTING</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#FF0000;"> <h2> 66% </h2></v-list-item-title>

      <v-card-actions>

                 <AccountingProgressBar class="m-center" />

        </v-card-actions>

        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Collected</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$184,759</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Pending</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$34,487</v-list-item-title>
      </v-column>
    </v-row>
</v-container>

      </v-list-item-content>
      </sequential-entrance>
           </Card>

         </Board>

       </main>

      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>

  </v-card>
      </v-flex>







       <v-flex
        sm6
        xs12
        md6
        lg12
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >


        <main class="flexbox">

         <Board id="board-5">
           <Card id="card-5" draggable="true">


 <sequential-entrance delay="2000" fromBottom>

      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>HR</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 94% </h2></v-list-item-title>

       <v-card-actions>

                 <HRProgressBar class="m-center" />

        </v-card-actions>


        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Payroll</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$28,424</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Staff</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >16</v-list-item-title>
      </v-column>
    </v-row>
</v-container>

      </v-list-item-content>
      </sequential-entrance>



           </Card>

         </Board>

       </main>

      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>

  </v-card>
      </v-flex>








       <v-flex
        sm6
        xs12
        md6
        lg12
      >
       <v-card class="theme-bg-card">
    <v-list-item>
   <sequential-entrance delay="1500" fromBottom>

     <v-list-item-content >


        <main class="flexbox">

         <Board id="board-6">
           <Card id="card-6" draggable="true">





   <sequential-entrance delay="2500" fromBottom>
      <v-list-item-content >
        <v-flex class="space3"></v-flex>
        <div class="overline text-center" style="color:#fff;"><h2>INFRASTRUCTURE</h2></div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;"> <h2> 88% </h2></v-list-item-title>

       <v-card-actions>

                 <InfrastructureProgressBar class="m-center" />

        </v-card-actions>


        <div><v-divider></v-divider></div>
        <v-flex class="space3"></v-flex>

<v-container class="data-tiles">
    <v-row justify="space-around">
      <v-column>
        <div class="overline text-center" style="color:#fff;">Overhead</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >$64,750</v-list-item-title>
      </v-column>
      <v-column>
        <div class="overline text-center" style="color:#fff;">Profit Margin</div>
        <v-list-item-title class="headline mb-1 text-center" style="color:#78b59c;" >78%</v-list-item-title>
      </v-column>
    </v-row>
</v-container>


      </v-list-item-content>
      </sequential-entrance>


           </Card>

         </Board>

       </main>

      </v-list-item-content>
      </sequential-entrance>
    </v-list-item>

  </v-card>
      </v-flex>








<!--

  <div class="middle">
      <div class="menu">
        <li class="item" id='profile'>
          <a href="#profile" class="btn"> <img src="@/assets/Cog_Icons_Sales_100px.png" height="50px" align="center" alt="">  Sales</a>
          <div class="smenu">
            <a href="#">Posts</a>
            <a href="#">Picture</a>
          </div>
        </li>

        <li class="item" id="messages">
          <a href="#messages" class="btn"><img src="@/assets/Cog_Icons_Marketing_100px.png" height="50px" align="center" alt=""> Marketing</a>
          <div class="smenu">
            <a href="#">new</a>
            <a href="#">Sent</a>
            <a href="#">Spam</a>
          </div>
        </li>

        <li class="item" id="settings">
          <a href="#settings" class="btn"><img src="@/assets/Cog_Icons_Operations_100px.png" height="50px" align="center" alt=""> Operations</a>
          <div class="smenu">
            <a href="#">Password</a>
            <a href="#">Language</a>
          </div>
        </li>


        <li class="item" id="settings">
          <a href="#settings" class="btn"><img src="@/assets/Cog_Icons_Marketing_100px.png" height="50px" align="center" alt=""> Infrastructure</a>
          <div class="smenu">
            <a href="#">Password</a>
            <a href="#">Language</a>
          </div>
        </li>



        <li class="item" id="settings">
          <a href="#settings" class="btn"><img src="@/assets/Cog_Icons_Financials_100px.png" height="50px" align="center" alt=""> Financial</a>
          <div class="smenu">
            <a href="#">Password</a>
            <a href="#">Language</a>
          </div>
        </li>


      </div>
    </div> -->
      </v-navigation-drawer>



   </nav>
</template>
<script>
import Board from "./Board";
import Card from "./Card";
import Popup from './Popup.vue';
import MarketingProgressBar from "@/components/MarketingProgressBar.vue";
import SalesProgressBar from "@/components/SalesProgressBar.vue";
import ProjectsProgressBar from "@/components/ProjectsProgressBar.vue";
import AccountingProgressBar from "@/components/AccountingProgressBar.vue";
import HRProgressBar from "@/components/HRProgressBar.vue";
import InfrastructureProgressBar from "@/components/InfrastructureProgressBar.vue";
export default {

  name: "Nav",
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    drawer: false,
    item: 1,
    items: [

        // { text: "Home", icon: "mdi-home", nav: "home" },
        { text: "Daily Briefing", icon: "mdi-clipboard-check", nav: "dailybriefing" },
        { text: "Interface", icon: "mdi-gesture-tap", nav: "interface" },
        { text: "Dashboard", icon: "mdi-view-quilt", nav: "dashboard" },
        { text: "Decision Tracker", icon: "mdi-view-quilt", nav: "decisiontracker" },
        // { text: "Widgets", icon: "mdi-view-module", nav: "widgets" },
        { text: "Departments", icon: "mdi-apps", nav: "departments" },
        { text: "Agenda", icon: "mdi-view-agenda", nav: "dailyagenda" },
        { text: "Training", icon: "mdi-cube-outline", nav: "training" },
        { text: "Appointments", icon: "mdi-calendar-text", nav: "appointments" },
        { text: "Forms", icon: "mdi-account-edit", nav: "forms" },
{
          text: "Sentimental Analysis",
          icon: "mdi-clock",
          nav: "sentimental-analysis"
        },
        { text: "Help", icon: "mdi-help", nav: "help" },
        { text: "Logout", icon: "mdi-flag", nav: "login", }


    ]
    }),
    components: {
    Card,
    Board,
    Popup,
    MarketingProgressBar,
    SalesProgressBar,
    ProjectsProgressBar,
    AccountingProgressBar,
    HRProgressBar,
    InfrastructureProgressBar,
  },

  methods: {
    nav(path) {
      this.$router.push({ name: path });
    }
  }
};

</script>

<style scoped>


.theme-bg-card {
  background: rgba(16, 22, 58, 0.0);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;

}

.theme-bg-card:hover {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  outline-style: solid;
	animation: glow 1800ms ease-out infinite alternate;
	border-color: #393;
	box-shadow: 0 0 5px rgba(0,255,0,.2), inset 0 0 5px rgba(0,255,0,.1), 0 2px 0 #000;
	color: #efe;
	outline: none;

}


.flexbox {
  display: flex;
  justify-content: space-between;

  width: 100%;
  max-width: 1200px;
  height: 47px;

  overflow: hidden;
  margin: 0 auto;
  padding: 0px;

}


.flexbox .board {
  display: flex;
  flex-direction: column;

  min-width: 200px;
  max-width: 90%;
  background-color:transparent;
  padding: 0px;

}


.flexbox .board .card {

  padding: 15px;
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;

  min-width: 380px;
  max-width: 380px;
  cursor: pointer;
}

.border {
  border-left: 4px solid #0ba518;
}

.space {
  height: 20px;
}

.drawer-color {
  background: #304057;
  width: 360px;
}




.navi {
  background: #304057;

}

.three-dot {
  margin-top: 10px;
  float: right;
  color: #0f1724;
}

.text-color-2 {
  color: #42da91 !important;
}

.logo {
  width: 12%;
}


.color {
 color: #
}
.user-info {
  cursor: pointer;
}
*{
  margin: 0;
  padding: 0;
  font-family: sans-serif;
  list-style: none;
  text-decoration: none;
}

.middle{
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 20px;
  transform: translate(-50%,-50%);
}
.menu{
  width: 300px;
  border-radius: 8px;
  list-style-type: none;
  transform-origin: top;
  transition: transform .4s ease-in-out;
  overflow: hidden;
  overflow: hidden;
}
.item{
  border-top: 1px solid #424242;
  overflow: hidden;
}
.btn{
  display: block;
  padding: 16px 20px;
  background: #424242;
  color: white;
  position: relative;
}
.btn:before{
  content: "";
  position: absolute;
  width: 14px;
  height: 14px;
  background:#424242;
  left: 20px;
  bottom: -7px;
  transform: rotate(45deg);
}
.btn i{
  margin-right: 10px;
}
.smenu{
  background: #333;
  overflow: hidden;
  transition: max-height 0.3s;
  max-height: 0;
}
.smenu a{
  display: block;
  padding: 16px 26px;
  color: white;
  font-size: 14px;
  margin: 4px 0;
  position: relative;
}
.smenu a:before{
  content: "";
  position: absolute;
  width: 6px;
  height: 100%;
  background: #424242;
  left: 0;
  top: 0;
  transition: 0.3s;
  opacity: 0;
}
.smenu a:hover:before{
  opacity: 1;
}
.item:target .smenu{
  max-height: 10em;
}



@media only screen and (max-width: 600px) {
  .logo {
    width: 15%;
  }
}
</style>
